<template>
  <div class="product-add common-page">
    <!-- 面包屑 -->
    <a-breadcrumb>
      <a-breadcrumb-item>产品管理</a-breadcrumb-item>
      <a-breadcrumb-item>添加产品</a-breadcrumb-item>
    </a-breadcrumb>

    <!-- 设备信息 -->
    <section class="common-box">
      <div class="common-box-title">产品信息</div>
      <div class="common-box-body">
        <a-form :form="form">
          <a-row>
            <a-col :span="8">
              <a-form-item label="产品名称" v-bind="formItemLayout">
                <a-input
                  placeholder="请输入产品名称"
                  maxlength="64"
                  v-decorator="[
                    'name',
                    {
                      rules: [
                        {
                          required: true,
                          message: '请输入产品名称',
                          whitespace: true,
                        },
                      ],
                    },
                  ]"
                />
              </a-form-item>
            </a-col>

            <a-col :span="8">
              <a-form-item label="授权算法编号" v-bind="formItemLayout">
                <a-input-number
                  placeholder="请输入授权算法编号"
                  :min="0"
                  style="width: 100%"
                  v-decorator="[
                    'algorithmType',
                    {
                      rules: [
                        { required: true, message: '请输入授权算法编号' },
                      ],
                    },
                  ]"
                />
              </a-form-item>
            </a-col>

            <a-col :span="8">
              <a-form-item
                label="产品类型编号"
                extra="取值范围0~9"
                v-bind="formItemLayout"
              >
                <a-input-number
                  placeholder="请输入产品类型编号"
                  :min="0"
                  :max="9"
                  style="width: 100%"
                  v-decorator="[
                    'type',
                    {
                      rules: [
                        { required: true, message: '请输入产品类型编号' },
                      ],
                    },
                  ]"
                />
              </a-form-item>
            </a-col>

            <a-col :span="8">
              <a-form-item label="描述" v-bind="formItemLayout">
                <a-textarea
                  placeholder="请输入描述"
                  maxlength="256"
                  :rows="4"
                  v-decorator="[
                    'description',
                    {
                      rules: [
                        {
                          required: false,
                          message: '请输入描述',
                          whitespace: true,
                        },
                      ],
                    },
                  ]"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </section>

    <!-- 产品功能 -->
    <section class="common-box">
      <div class="common-box-title">产品功能</div>
      <div class="common-box-body">
        <a-table
          :columns="columns_func"
          :rowKey="(record, index) => index"
          :dataSource="data_func"
          :pagination="false"
        >
          <!-- 功能名称 -->
          <template slot="id" slot-scope="text, record">
            <a-select
              v-if="record.editable"
              :value="text"
              @change="(e) => handleChange(e, record.index, 'id')"
              style="margin: -6px 0; width: 50%"
            >
              <a-select-option
                v-for="func in functions_select"
                :key="func.id"
                :value="func.id"
                :disabled="func.disabled"
                >{{ func.name }}</a-select-option
              >
            </a-select>
            <span v-else>{{ getFuncNameByID(text) }}</span>
          </template>

          <!-- 产品功能操作 -->
          <template slot="action" slot-scope="text, record">
            <template v-if="record.editable">
              <span v-if="record.isNew" class="cant-select">
                <a @click="saveRow(record)">添加</a>
                <a-divider type="vertical" />
                <a-popconfirm
                  title="是否要删除此行？"
                  @confirm="remove(record.index)"
                >
                  <a>删除</a>
                </a-popconfirm>
              </span>
              <span v-else class="cant-select">
                <a @click="saveRow(record)">保存</a>
                <a-divider type="vertical" />
                <a @click="cancel(record.index)">取消</a>
              </span>
            </template>
            <span v-else class="cant-select">
              <a @click="toggle(record.index)">编辑</a>
              <a-divider type="vertical" />
              <a-popconfirm
                title="是否要删除此行？"
                @confirm="remove(record.index)"
              >
                <a>删除</a>
              </a-popconfirm>
            </span>
          </template>
        </a-table>
        <a-button
          style="width: 100%; margin-top: 16px; margin-bottom: 8px"
          type="dashed"
          icon="plus"
          @click="newMember"
          >新增功能</a-button
        >
      </div>
    </section>

    <!-- 扩展属性 -->
    <section class="common-box">
      <div class="common-box-title">扩展属性</div>
      <div class="common-box-body">
        <a-table
          :columns="columns_attr"
          :rowKey="(record, index) => index"
          :dataSource="data_attr"
          :pagination="false"
        >
          <!-- 类型 -->
          <template slot="type" slot-scope="text, record">
            <div v-if="record.editable">
              <a-checkbox
                v-model="record.p"
                @change="
                  (e) => handleChangeAttr(e.target.checked, record.index, 'p')
                "
              >
                p
              </a-checkbox>
              <a-checkbox
                v-model="record.u"
                @change="
                  (e) => handleChangeAttr(e.target.checked, record.index, 'u')
                "
              >
                u
              </a-checkbox>
            </div>
            <span v-else
              >{{ record.p || record.u ? "[" : "" }}{{ record.p ? "p" : ""
              }}{{ record.p && record.u ? ";" : "" }}{{ record.u ? "u" : ""
              }}{{ record.p || record.u ? "]" : "" }}</span
            >
          </template>
          <!-- 属性名 -->
          <template slot="key" slot-scope="text, record">
            <a-input
              maxlength="64"
              :allowClear="false"
              :value="text"
              v-if="record.isNew"
              style="margin: -6px 0"
              @change="
                (e) => handleChangeAttr(e.target.value, record.index, 'key')
              "
            />
            <span v-else>{{ text }}</span>
          </template>

          <!-- 属性英文名 -->
          <template slot="key_en" slot-scope="text, record">
            <a-input
              maxlength="64"
              :allowClear="false"
              :value="text"
              v-if="record.isNew"
              style="margin: -6px 0"
              @change="
                (e) => handleChangeAttr(e.target.value, record.index, 'key_en')
              "
            />
            <span v-else>{{ text }}</span>
          </template>

          <!-- 值 -->
          <template slot="value" slot-scope="text, record">
            <a-input
              maxlength="64"
              :allowClear="false"
              :value="text"
              v-if="record.editable"
              style="margin: -6px 0"
              @change="
                (e) => handleChangeAttr(e.target.value, record.index, 'value')
              "
            />
            <span v-else>{{ text }}</span>
          </template>

          <!-- 扩展属性操作 -->
          <template slot="action" slot-scope="text, record">
            <template v-if="record.editable">
              <span v-if="record.isNew" class="cant-select">
                <a @click="saveRowAttr(record)">添加</a>
                <a-divider type="vertical" />
                <a-popconfirm
                  title="是否要删除此行？"
                  @confirm="removeAttr(record.index)"
                >
                  <a>删除</a>
                </a-popconfirm>
              </span>
              <span v-else class="cant-select">
                <a @click="saveRowAttr(record)">保存</a>
                <a-divider type="vertical" />
                <a @click="cancelAttr(record.index)">取消</a>
              </span>
            </template>
            <span v-else class="cant-select">
              <a @click="toggleAttr(record.index)">编辑</a>
              <a-divider type="vertical" />
              <a-popconfirm
                title="是否要删除此行？"
                @confirm="removeAttr(record.index)"
              >
                <a>删除</a>
              </a-popconfirm>
            </span>
          </template>
        </a-table>
        <a-button
          style="width: 100%; margin-top: 16px; margin-bottom: 8px"
          type="dashed"
          icon="plus"
          @click="newMemberAttr"
          >新增扩展属性</a-button
        >
      </div>
    </section>

    <section class="submit-box">
      <a-button type="primary" @click="submit" :loading="loading"
        >提交</a-button
      >
    </section>
  </div>
</template>

<script>
import { addProduct, queryFunctions } from "../api/api";
const columns_func = [
  {
    title: "功能名称",
    dataIndex: "id",
    scopedSlots: { customRender: "id" },
    width: "50%",
  },
  {
    title: "操作",
    dataIndex: "action",
    scopedSlots: { customRender: "action" },
    width: "50%",
  },
];

const columns_attr = [
  {
    title: "类型",
    dataIndex: "type",
    scopedSlots: { customRender: "type" },
    width: "20%",
  },
  {
    title: "属性名",
    dataIndex: "key",
    scopedSlots: { customRender: "key" },
    width: "20%",
  },
  {
    title: "属性英文名",
    dataIndex: "key_en",
    scopedSlots: { customRender: "key_en" },
    width: "20%",
  },
  {
    title: "属性值",
    dataIndex: "value",
    scopedSlots: { customRender: "value" },
    width: "20%",
  },
  {
    title: "操作",
    dataIndex: "action",
    scopedSlots: { customRender: "action" },
    width: "20%",
  },
];

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
};

export default {
  name: "product-add",

  data() {
    return {
      form: this.$form.createForm(this),
      formItemLayout,
      columns_func,
      columns_attr,
      data_func: [],
      data_attr: [],
      functions: [],
      loading: false,
    };
  },

  computed: {
    functions_select() {
      let arr = [...this.functions];
      arr.forEach((item) => {
        item.disabled = false;
      });
      for (let i = 0; i < this.data_func.length; i++) {
        for (let j = 0; j < arr.length; j++) {
          if (this.data_func[i].id == arr[j].id) {
            arr[j].disabled = true;
          }
        }
      }
      return arr;
    },
  },

  created() {
    this.queryFunctions();
  },

  methods: {
    onChange(e) {},
    queryFunctions() {
      queryFunctions().then((res) => {
        if (res.error.code === 0) {
          this.functions = res.response ? res.response.functions : [];
        }
      });
    },

    getFuncNameByID(id) {
      let obj = this.functions.find((item) => item.id === id);
      return obj && obj.name;
    },

    submit() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.loading = true;
          let product = {
            name: values.name,
            type: values.type,
            algorithmType: values.algorithmType,
            description: values.description,
            functionsID: this.data_func.map((item) => item.id),
            extendedAttributes: this.data_attr.map((item) => {
              if (item.p == false && item.u == false) {
                return {
                  key: item.key,
                  key_en: item.key_en,
                  value: item.value,
                };
              } else {
                let p = item.p ? "p" : "";
                let u = item.u ? "u" : "";
                let list = `[${p}${p && u ? ";" : ""}${u}]`;
                item.type = list;
                return {
                  key: list + item.key,
                  key_en: item.key_en,
                  value: item.value,
                };
              }
            }),
          };
          if (product.functionsID.length === 0) {
            this.$message.error("至少添加一个产品功能，且不可重复");
            this.loading = false;
            return;
          }

          if (
            this.data_func.some((item) => {
              return item.editable === true;
            })
          ) {
            this.$message.error("请点击【添加】【保存】产品功能");
            this.loading = false;
            return;
          }

          if (
            this.data_attr.some((item) => {
              return item.editable === true;
            })
          ) {
            this.$message.error("请点击【添加】【保存】扩展属性");
            this.loading = false;
            return;
          }
          addProduct(product).then((res) => {
            if (res.error.code === 0) {
              this.$message.success("添加成功");
            }
            this.loading = false;
          });
        }
      });
    },
    newMember() {
      const length = this.data_func.length;
      this.data_func.push({
        index:
          length === 0
            ? "1"
            : (parseInt(this.data_func[length - 1].index) + 1).toString(),
        id: "",
        editable: true,
        isNew: true,
      });
    },

    remove(index) {
      const newData = this.data_func.filter((item) => item.index !== index);
      this.data_func = newData;
    },

    saveRow(record) {
      const { index, id } = record;
      if (id === "") {
        this.$message.error("请填写完整信息");
        return;
      }
      const target = this.data_func.find((item) => item.index === index);
      target.editable = false;
      target.isNew = false;
    },

    toggle(index) {
      const target = this.data_func.find((item) => item.index === index);
      target._originalData = { ...target };
      target.editable = !target.editable;
    },

    cancel(index) {
      const target = this.data_func.find((item) => item.index === index);
      Object.keys(target).forEach((key) => {
        target[key] = target._originalData[key];
      });
      target._originalData = undefined;
    },

    handleChange(value, index, column) {
      const newData = [...this.data_func];
      const target = newData.find((item) => index === item.index);
      if (target) {
        target[column] = value;
        this.data_func = newData;
      }
    },

    newMemberAttr() {
      const length = this.data_attr.length;
      this.data_attr.push({
        index:
          length === 0
            ? "1"
            : (parseInt(this.data_attr[length - 1].index) + 1).toString(),
        key: "",
        key_en: "",
        p: false,
        u: false,
        type: [],
        value: "",
        editable: true,
        isNew: true,
      });
    },

    removeAttr(index) {
      const newData = this.data_attr.filter((item) => item.index !== index);
      this.data_attr = newData;
    },

    saveRowAttr(record) {
      const { index, key, key_en, value } = record;
      if (key === "" || key_en === "" || value === "") {
        this.$message.error("请填写完整信息");
        return;
      }

      if (
        this.data_attr.filter(
          (item) => item.key.replace(/\s*/g, "") === key.replace(/\s*/g, "")
        ).length > 1
      ) {
        this.$message.error("存在重复的属性名");
        return;
      }

      const target = this.data_attr.find((item) => item.index === index);
      target.editable = false;
      target.isNew = false;
    },

    toggleAttr(index) {
      const target = this.data_attr.find((item) => item.index === index);
      target._originalData = { ...target };
      target.editable = !target.editable;
    },

    cancelAttr(index) {
      const target = this.data_attr.find((item) => item.index === index);
      Object.keys(target).forEach((key) => {
        target[key] = target._originalData[key];
      });
      target._originalData = undefined;
    },

    handleChangeAttr(value, index, column) {
      const newData = [...this.data_attr];
      const target = newData.find((item) => index === item.index);
      if (target) {
        target[column] = value;
        this.data_attr = newData;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.product-add {
  margin-bottom: 56px;
}
</style>